module.exports = __webpack_public_path__ + "img/6.0c2b187a.png";